import { PulseBaseProvider } from '../../base-classes';
import { getTemperature } from '../../utilities/unitConversion';
import { unitSystems } from '../../utilities/units';

const _averageObsUri = '/data/climate/v1/daily/ByLatitudeAndLongitude/gridded';
const _averageObsCacheKey = 'averageObs';

export class AverageObsProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_averageObsCacheKey] = this.averageObsSyncer.bind(this);
    }

    async averageObsSyncer(params) {
        const { id, syncParams, resolve, reject } = params;

        const queryParams = {
            ...syncParams.stdParameters,
            latitude: syncParams.latitude,
            longitude: syncParams.longitude,
            startdatetimeutc: syncParams.startdatetimeutc,
            enddatetimeutc: syncParams.enddatetimeutc,
            units: unitSystems.english,
            verbose: syncParams.verbose
        };

        const { tempUnit } = syncParams;
        const unitConversionFunc = (result) => {
            if (result?.d) {
                result.d.forEach(resultHiLow => {
                    resultHiLow.ClimoAvg_DlyMinAirTemp_F = getTemperature(resultHiLow.ClimoAvg_DlyMinAirTemp_F, tempUnit);
                    resultHiLow.ClimoAvg_DlyMaxAirTemp_F = getTemperature(resultHiLow.ClimoAvg_DlyMaxAirTemp_F, tempUnit);
                });
            }
            return result;
        };

        return await super.syncData(syncParams.key, id, queryParams, _averageObsUri, resolve, reject, null, syncParams.pulseApi, null, unitConversionFunc);
    }

    async getAverageObs(latitude, longitude, startdatetimeutc, enddatetimeutc, units, stdParameters, verbose, refresh = false, lengthUnit, tempUnit, pressureUnit, speedUnit) {
        const syncParams = {
            latitude,
            longitude,
            startdatetimeutc,
            enddatetimeutc,
            units: units ? units : unitSystems.english,
            verbose: !!verbose,
            refresh,
            lengthUnit,
            tempUnit,
            pressureUnit,
            speedUnit
        };

        const id = JSON.stringify(syncParams);

        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_averageObsCacheKey, id);
        }
        return await super.loadFromStorage(_averageObsCacheKey, id, syncParams);
    }
}

